import { type ServiceMethod } from '@/application/interfaces/service';

export type PostalCode = {
  description?: string | null;
  number: string;
  type: string;
};

export type Body = {
  city: string;
  complement?: string;
  district: string;
  ibgeCityCode: string;
  nickname?: string;
  number: string;
  reference?: string;
  state: string;
  street: string;
  postalCode: PostalCode;
};

export type AddressResponse = {
  city: string;
  complement: string;
  district: string;
  ibgeCode: string;
  number: string;
  reference: string;
  state: string;
  street: string;
  main: boolean;
  externalSource: boolean;
  hasGarden: boolean;
  hasPool: boolean;
  nickname: string;
  hash: string;
  postalCode: PostalCode;
};

export type Response = {
  data: {
    identifier: number;
    type: string;
    addresses: AddressResponse[];
  };
};

export type ErrorResponse = {
  errors: {
    code: string;
    message: string;
  }[];
};

const postAddress: ServiceMethod<Response, Body> =
  (httpClient) => async (data, options) => {
    const { body: response } = await httpClient.post<Response, Body>(
      '/api/v3/account/addresses',
      {
        ...options,
        body: data,
      }
    );

    return response;
  };

export default postAddress;
